<template>
  <div class="">
    <template v-for="link in topNav">
      <router-link
          v-if="link.visible"
          :to="{ name: link.to }"
          class="page_sidenav--link"
      >
        <icon-default
            class="page_sidenav--link--icon"
            :icon="link.icon"
        ></icon-default>

        <span
            class="page_sidenav--link--text"
        >{{ link.label }}</span>

        <badge-default
            v-if="link.badge"
            class="page_sidenav--link--badge"
            :count="link.badge"
        ></badge-default>
      </router-link>
    </template>
  </div>
</template>

<script>
import localStorageService from "../../services/localStorage";

export default {
  name: "PageSidenav",
  computed: {
    topNav() {
      // This is not in data because the badges need to by dynamic
      return [
        {
          to: 'user-dashboard',
          icon: 'user-dashboard',
          label: 'Dashboard',
          badge: null,
          visible: true,
        },
        {
          to: 'inbox',
          icon: 'inbox',
          label: 'Inbox',
          badge: this.inboxBadge,
          visible: true,
        },
        {
          to: 'pipeline',
          icon: 'pipeline',
          label: 'Pipeline',
          badge: null,
          visible: true,
        },
        {
          to: 'leads',
          icon: 'lead',
          label: 'Leads',
          badge: null,
          visible: true,
        },
        {
          to: 'up-next',
          icon: 'up-next',
          label: 'Up Next',
          // badge: this.upNextBadge,
          badge: null,
          visible: true,
        },
        {
          to: 'comms',
          icon: 'comms',
          label: 'Comms',
          badge: null,
          visible: this.canAccessCommLogs,
        },
        {
          to: 'contacts',
          icon: 'contacts',
          label: 'Contacts',
          badge: null,
          visible: true,
        },
        {
          to: 'campaigns',
          icon: 'campaign',
          label: 'Campaigns',
          badge: null,
          visible: true,
        },
        {
          to: 'stats',
          icon: 'stats',
          label: 'Stats',
          badge: null,
          visible: true,
        },
        {
          to: 'store',
          icon: 'store',
          label: 'Store',
          badge: null,
          visible: true,
        },
        {
          to: 'settings',
          icon: 'settings',
          label: 'Settings',
          badge: null,
          visible: this.canAccessSettings,
        },
      ]
    },
    userId() {
      return localStorageService.getAuthUser().id;
    },
    activeUser() {
      return this.$store.getters.authUser;
    },
    canAccessCommLogs() {
      return this.activeUser.is_owner || this.activeUser.can_access_comm_log_page;
    },
    canAccessSettings() {
      return this.activeUser.is_owner || this.activeUser.can_access_settings;
    },
    inboxBadge() {
      return this.$store.getters.inboxBadge;
    },
    // upNextBadge() {
    //   return this.$store.getters.tasksBadge;
    // },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.page_sidenav--link {
  position: relative;
  display: block;
  margin-bottom: 8px;
  padding: 6px 3px 6px 0;
  border-left: 3px solid $white;
  color: $text-light;
  text-align: center;

  &:hover {
    background-color: $background;
    border-left-color: $background;
    color: $text-muted;
  }

  &.parent {
    color: $primary!important; // want to make sure this happens even when hovering
    border-left-color: $primary!important; // want to make sure this happens even when hovering
  }

  &--icon {
    margin-bottom: 4px;
  }

  &--text {
    display: block;
    font-size: 7px;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  &--badge {
    position: absolute;
    left: 85%;
    top: 10px; // this centers the badge with the icon
  }
}

.page_sidenav--avatar {
  width: 100%;
  text-align: center;
}
</style>
